import { createContext, useContext, useState, type ReactNode } from 'react'

interface ChatBotContextValue {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

const ChatBotContext = createContext<ChatBotContextValue | null>(null)

export function ChatBotProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ChatBotContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </ChatBotContext.Provider>
  )
}

export function useChatBot() {
  const context = useContext(ChatBotContext)
  if (!context) {
    throw new Error('useChatBot must be used within a ChatBotProvider')
  }
  return context
}
